import { render, staticRenderFns } from "./ValueUnitModal.vue?vue&type=template&id=3bed13f6&"
import script from "./ValueUnitModal.vue?vue&type=script&lang=js&"
export * from "./ValueUnitModal.vue?vue&type=script&lang=js&"
import style0 from "./ValueUnitModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports